import styled from 'styled-components';

export const Container = styled.div`
  transition: 150ms all;

  & > * {
    transition: 150ms all;
    &.none {
      outline: 2px dashed transparent;
    }
    &.active {
      outline: 2px dashed ${({ theme: { color } }) => color.s2};
    }
  }
`;
